import { useMutation } from '@tanstack/react-query';

import { AxiosResponse } from 'axios';
import {
  createUser,
  disableUserById,
  enableUserById,
  editUserById,
} from '../services/userServices';
import UserItemDto from '../models/dto/user-item.dto';

export const useEnableUser = () => {
  const useEnableUserMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableUserById(mutationVariables.id));

  return useEnableUserMutation;
};

export const useDisableUser = () => {
  const useDisableUserMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => disableUserById(mutationVariables.id));

  return useDisableUserMutation;
};

export const useCreateUserRequest = () => {
  const useEnablUserMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { payload: UserItemDto; userType: 'enterprise' | 'establishment' },
    unknown
  >((mutationVariables) =>
    createUser(mutationVariables.payload, mutationVariables.userType),
  );

  return useEnablUserMutation;
};

export const useEditUserRequest = () => {
  const editUserRequestMutation = useMutation<
    AxiosResponse<Partial<UserItemDto>>,
    unknown,
    {
      payload: Partial<UserItemDto>;
      id: string | undefined;
      userType: 'enterprise' | 'establishment';
    },
    unknown
  >(({ id, payload, userType }) => editUserById(id, payload, userType));

  return editUserRequestMutation;
};
